/**
 * Main Component for Footer
 *
 * @author Owen Burns
 */

import {
  CopyrightText,
  FooterContainer,
  FooterCopyright,
  FooterIcons,
  FooterInnerContainer,
} from "./styling/Footer.styles";
import { Instagram, LinkedIn, Github } from "@/assets";

const Footer = () => {
  return (
    <FooterContainer>
      <FooterInnerContainer>
        <FooterIcons>
          <a>
            <img src={Instagram} alt="instagram" />
          </a>

          <a href="https://www.linkedin.com/in/owenburns01/">
            <img src={LinkedIn} alt="linkedin" />
          </a>

          <a href="https://github.com/Creator-Solutions">
            <img src={Github} alt="github" />
          </a>
        </FooterIcons>
        <FooterCopyright>
          <CopyrightText>© Owen Burns 2024</CopyrightText>
        </FooterCopyright>
      </FooterInnerContainer>
    </FooterContainer>
  );
};

export default Footer;
